<div class="app-topbar">
   <div class="flex justify-between tablet:pl-4 tablet:pr-7 items-center gap-3 basic-shadow">
      <div
         style="background-size: 100%"
         class="bg-topbar-logo bg-no-repeat w-[80px] tablet:w-[170px] h-[60px] bg-center cursor-pointer"
         (click)="goToPMPHome()"
      ></div>

      @if (userName) {
         <div class="flex gap-3">
            <p-menu
               #menu
               [popup]="true"
               [model]="items ?? []"
               appendTo="body"
               styleClass="topbarmenu"
            ></p-menu>
            <p-button
               id="accountToolbarButton"
               styleClass="!w-auto !p-0 !text-app-accent-2 !bg-white !border-none"
               icon="pi pi-angle-down"
               (click)="menu.toggle($event)"
            >
               <div class="flex gap-2 text-xs text-nowrap text-app-dark-gray items-center">
                  <span
                     class="w-[24px] h-[24px] fill-app-accent-2"
                     [inlineSVG]="'assets/icons/app-user-icon.svg'"
                  ></span>
                  <span>{{ 'welcome' | translate }},</span>
                  <span class="font-extrabold mr-2 max-w-[108px] overflow-hidden text-ellipsis tablet:max-w-[170px]">{{ userName }}</span>
               </div>
            </p-button>
         </div>
      }
   </div>
</div>
